import { render, staticRenderFns } from "./cpt-structure.vue?vue&type=template&id=108e2618&scoped=true"
import script from "./cpt-structure.vue?vue&type=script&lang=js"
export * from "./cpt-structure.vue?vue&type=script&lang=js"
import style0 from "./cpt-structure.vue?vue&type=style&index=0&id=108e2618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e2618",
  null
  
)

export default component.exports